module.exports = "/_next/static/images/AIReadyData-c29bbe39e64834caafc7a7bc9a06728e.webp";